(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Team"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("shopify:section:load", initSwiper)
document.addEventListener("DOMContentLoaded", initSwiper)

function initSwiper(){
  if (window.innerWidth <= 768 && typeof Swiper !== "undefined") {
    new Swiper('.myTeamSwiper', {
      slidesPerView: 1,
      spaceBetween: 14,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}

  } catch(e) { console.error(e); }
})();
})();
